interface DataLayerItem {
	user_id: string;
}
declare global {
	interface Window {
		dataLayer: DataLayerItem[];
	}
}
/** Attaches the identity event to all forms. */
export function rtIdentity(): void {
	const forms = Array.from(document.querySelectorAll("form"));
	for (const form of forms) {
		form.addEventListener("submit", () => handleSubmit(form));
	}
}

/**
 * Handles the form submit event. Adds the user ID to the data layer.
 *
 * @param form The form to identify to analytics.
 */
function handleSubmit(form: HTMLFormElement): void {
	const emailField = form.querySelector<HTMLInputElement>(
		`input[type="email"], input[name="email"]`,
	);
	if (emailField?.value && window.dataLayer) {
		window.dataLayer.push({
			user_id: emailField.value,
		});
	}
}
